export default function buildTradeId(makerId, takerId) {
  return `${makerId}__${takerId}`;
}
